export const bellNumbers = [
  1,
  2,
  5,
  15,
  52,
  203,
  877,
  4140,
  21147,
  115975,
  678570,
  4213597,
  27644437,
  190899322,
  1382958545,
  10480142147,
  82864869804,
  682076806159,
  5832742205057,
  51724158235372,
  474869816156751,
  4506715738447323,
]
